import { DefaultContextControl } from "shared/widgets/DefaultContextControl"
import { useContextManager } from 'shared/hooks/useContextManager'
import { useAppSelector } from 'shared/hooks'
import { selectContextLocationSearchString } from 'store/applicationSlice'
import { useContextSpyId } from 'shared/hooks/useContextSpyId'
import { useContextLocation } from 'shared/hooks/useContextLocation'
import { useContextSpyLaunchSettings } from 'shared/hooks/useContextSpyLaunchSettings1'
import { useContextFilters } from 'shared/hooks/useContextFilters'
import { useEventBus } from "shared/providers/EventBusProvider"

export const DefaultContextControlContainer = () => {
    useContextManager()
    const { emit } = useEventBus()

    const locationString: any = useAppSelector(selectContextLocationSearchString)

    const {
        selectContextSpyId,
        setContextSpyId
    } = useContextSpyId()

    const {
        selectContextLocation,
        setContextLocation
    } = useContextLocation()

    const {
        selectContextSpyLaunchSettings,
        setContextSpyLaunchSettings
    } = useContextSpyLaunchSettings()

    const {
        selectContextFilters,
        setContextFilters
    } = useContextFilters()

    const handleDefaultContextContainerLocationChange = (event: any) =>{
        setContextLocation(event)
        setContextSpyId(undefined)

        if (event !== undefined){
            emit('defaultContextControl:search', {
                location: event
            })
        } 

        if (event !== undefined){
            emit('defaultContextControl:locationChange', {
                location: event
            })
        } 
    }

    const handleDefaultContextContainerSpyLaunchSettingsChange = (event: any) => {
        setContextSpyLaunchSettings(event)

        if (event !== undefined){
            emit('defaultContextControl:spyLaunchSettingsChange', {
                spyLaunchSettings: event
            })
        } 
    }

    const handleDefaultContextContainerFiltersChange = (event: any) => {
        setContextFilters(event)

        if (event !== undefined){
            emit('defaultContextControl:filtersChange', {
                filters: event
            })
        } 
    }

    const handleDefaultContextContainerLocationSearchStringChange = () => {
        //console.log('handleDefaultContextContainerLocationSearchStringChange')
    }

    const handleDefaultContextContainerSearch = (event: any) => {
        emit('defaultContextControl:search', event)
    }

    return (
        <DefaultContextControl
            location={selectContextLocation}
            locationSearchString={locationString}
            filter={selectContextFilters}
            spyLaunchSettings={selectContextSpyLaunchSettings}
            onLocationChange={handleDefaultContextContainerLocationChange}
            onFiltersChange={handleDefaultContextContainerFiltersChange}
            onLocationSearchStringChange={handleDefaultContextContainerLocationSearchStringChange}
            onSpyLaunchSettingsChange={handleDefaultContextContainerSpyLaunchSettingsChange}
            onSearch={handleDefaultContextContainerSearch}
        />
    )
}